var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04 17.0544C9.05 14.5444 10.19 11.6744 14.5 10.7144C14.5 10.7144 9.5 10.7144 7.88 15.3444C7.88 15.3444 7 14.4644 7 13.4644C7 12.4644 8 10.3444 10.5 9.84436C11.21 9.71436 12 9.58436 12.78 9.47436C14.75 9.21436 16.64 8.93436 17 8.21436C17 8.21436 15.5 16.7144 10 16.7144C9.82 16.7144 9.57 16.6544 9.33 16.5644L8.86 17.7144L7.91 17.3844L8.04 17.0544ZM12 4.71436C16.41 4.71436 20 8.30436 20 12.7144C20 17.1244 16.41 20.7144 12 20.7144C7.59 20.7144 4 17.1244 4 12.7144C4 8.30436 7.59 4.71436 12 4.71436ZM12 2.71436C6.5 2.71436 2 7.21436 2 12.7144C2 18.2144 6.5 22.7144 12 22.7144C17.5 22.7144 22 18.2144 22 12.7144C22 7.21436 17.5 2.71436 12 2.71436Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganic);
export default __webpack_public_path__ + "static/media/organic.437382a7af8a309495a8fb5f5d7d7da0.svg";
export { ForwardRef as ReactComponent };